import { createContext, useContext } from "react";

export type Flavour = {
  title: string;
  index: number;
  imageUrl: string;
  color: string;
  theme: "light" | "dark";
};
export const FlavourCarouselContext = createContext<{
  isInversed?: boolean;
}>({
  isInversed: false,
});

export const FlavourCarouselSlide = createContext<{ slideIndex?: number }>({});

export const useFlavourCarousel = () => {
  return useContext(FlavourCarouselContext);
};
